import React, { useEffect, useState, useContext, useCallback } from 'react';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';


const style = {
    textAlign: "center",
    marginTop: 30
}

const imgStyle = {
    maxWidth: "100%"
}

export default function PokeSprites(props) {
    function flattenObject(ob) {
        var toReturn = {};
    
        for (var i in ob) {
            if (!ob.hasOwnProperty(i)) continue;
    
            if ((typeof ob[i]) == 'object' && ob[i] !== null) {
                var flatObject = flattenObject(ob[i]);
                for (var x in flatObject) {
                    if (!flatObject.hasOwnProperty(x)) continue;
    
                    toReturn[i + '.' + x] = flatObject[x];
                }
            } else {
                toReturn[i] = ob[i];
            }
        }
        return toReturn;
    }

    const sprites = Object.values(flattenObject(props.pokemon.sprites)).filter(s => s)

    const spriteObjects = sprites.map((sprite, i) => {
        return {index: i, image: sprite}
    })

    const spriteImages = spriteObjects.map((sprite, i) => {
        return (
            <Grid item xs={6} sm={2}>
                <img src={sprite.image} style={imgStyle} />
            </Grid>
        )
    })


    return (
        <>
            <Container maxWidth="lg">
            <Grid container spacing={6}>
                {spriteImages}
                </Grid>
            </Container>
        </>
    )
}